var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartrate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H20C24.4183 0 28 3.58172 28 8V20C28 24.4183 24.4183 28 20 28H8C3.58172 28 0 24.4183 0 20V8Z",
    fill: "#EAF4FD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_535_22225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5018 9.37499C19.1824 9.05374 18.8026 8.7988 18.3843 8.62484C17.966 8.45088 17.5174 8.36133 17.0643 8.36133C16.6113 8.36133 16.1627 8.45088 15.7444 8.62484C15.3261 8.7988 14.9463 9.05374 14.6268 9.37499L14.0018 10.0625L13.3768 9.37499C12.7304 8.72852 11.8536 8.36534 10.9393 8.36534C10.0251 8.36534 9.1483 8.72852 8.50183 9.37499C7.85537 10.0215 7.49219 10.8982 7.49219 11.8125C7.49219 12.7267 7.85537 13.6035 8.50183 14.25L14.0018 19.75L19.5018 14.25C19.8231 13.9305 20.078 13.5507 20.252 13.1324C20.4259 12.7141 20.5155 12.2655 20.5155 11.8125C20.5155 11.3594 20.4259 10.9109 20.252 10.4926C20.078 10.0742 19.8231 9.69444 19.5018 9.37499Z",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#004276"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_535_22225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(6.5 6.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartrate);
export default __webpack_public_path__ + "static/media/heart rate.656389ec494c078494d42c053d05403d.svg";
export { ForwardRef as ReactComponent };